import axios from 'axios'
import { useState, useContext, forwardRef, useImperativeHandle } from "react"
import { UserContext } from '../../hooks/UserContext';
import { Button, Form, Modal } from "react-bootstrap"

const NewCard = forwardRef(({ selectedCourse, selectedTopic, addCardNode }, ref) => {
  const [show, setShow] = useState(false);
  const { user } = useContext(UserContext);

  // Form data
  const [position, setPosition] = useState();
  const [topic, setTopic] = useState();
  const [topicOptions, setTopicOptions] = useState([]);

  const handleClose = () => {
    setShow(false);
  }

  const handleShow = (targetTopicId) => {
    setShow(true);
    getTopicOptions(targetTopicId);
  }

  useImperativeHandle(ref, () => ({
    // targetTopicId: the topic node the user invoked "Add Card" on.
    openModal: (targetTopicId) => handleShow(targetTopicId),
  }));

  const createCard = async () => {
    let url = "/api/cards";
    let data;

    try {
      const response = await axios.post(url, {
        position_id: position ? parseInt(position) : null,
        body: "",
        topic_id: topic
      }, {
        headers: { 'Authorization': `Bearer ${user.token}`, 'X-EDITOR': 'nanoms' },
      });

      data = response.data;
    } catch (error) {
      console.error(error);
    }

    setPosition()

    return data
  }

  const handleTopicChange = (event) => {
    setTopic(parseInt(event.target.value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShow(false);
    const result = await createCard();
    if (!result) return;
    const cardNode = {
      "key": `${result.topic_id}-${result.id}`,
      "label": `${result.position_id}. card${result.id}`,
      "data": result.body,
      "position_id": result.position_id,
      "cardId": result.id
    };
    addCardNode(cardNode);
  }

  const getTopicOptions = async (targetTopicId) => {
    const res = await axios.get(`/api/courses/${selectedCourse.id}/topics`, {
      headers: { 'Authorization': `Bearer ${user.token}`, 'X-EDITOR': 'nanoms' }
    });

    const options = res.data.items.map(d => ({
      "value": d.id,
      "label": d.name
    }))

    if (options.length === 0) return;

    const defaultId = targetTopicId ?? selectedTopic?.id;
    const defaultOption = options.find(o => o.value === defaultId) || options[0];
    setTopic(defaultOption.value);
    setTopicOptions(options)
  }


  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Card</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="formParentTopic">
            <Form.Label>Topic: </Form.Label>
            <Form.Control as="select" value={topic} onChange={handleTopicChange}>
              {
                topicOptions.map((option, index) => {
                  return (<option key={index} value={option.value}>{option.label}</option>)
                })
              }
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="formCardPosition">
            <Form.Label>Position: </Form.Label>
            <Form.Control type="text" onChange={e => setPosition(e.target.value)} value={position} placeholder="Can be empty or number" />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
});

export default NewCard;